var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#2A66BC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8243_37446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.178 28.919H31.2432L31.2735 28.8613C31.6473 28.1521 32.5733 27.4533 33.9728 27.4533C35.4426 27.4533 36.2848 27.9178 36.7683 28.6726C37.2591 29.4388 37.3953 30.5253 37.3953 31.803V36.9404H34.7004V32.3933C34.7004 31.846 34.6894 31.1944 34.4783 30.6794C34.3715 30.4189 34.2118 30.1884 33.9728 30.0236C33.7335 29.8586 33.4237 29.7658 33.0275 29.7658C32.2251 29.7658 31.7247 30.0827 31.4323 30.574C31.1459 31.055 31.0672 31.6896 31.0672 32.3145V36.9404H28.4144V27.6221H31.0672V28.811V28.919H31.1752H31.178ZM26.3425 36.9404H23.6054V27.6221H26.3425V36.9404ZM25.0165 22.8549C25.9109 22.8549 26.6372 23.5813 26.6372 24.4764C26.6372 25.3718 25.9109 26.0983 25.0165 26.0983C24.1184 26.0983 23.3941 25.3718 23.3941 24.4764C23.3941 23.5813 24.1184 22.8549 25.0165 22.8549ZM41.1922 21.7344V38.2719C41.1922 39.608 40.1051 40.6951 38.7689 40.6951H22.2314C20.8953 40.6951 19.8082 39.608 19.8082 38.2719V21.7344C19.8082 20.3982 20.8953 19.3111 22.2314 19.3111H38.7689C40.1051 19.3111 41.1922 20.3982 41.1922 21.7344ZM39.7207 21.7344C39.7207 21.2095 39.2938 20.7826 38.7689 20.7826H22.2314C21.7066 20.7826 21.2797 21.2095 21.2797 21.7344V38.2719C21.2797 38.7967 21.7066 39.2236 22.2314 39.2236H38.7689C39.2938 39.2236 39.7207 38.7967 39.7207 38.2719V21.7344Z",
    fill: "white",
    stroke: "#3F5F9C",
    strokeWidth: 0.216
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8243_37446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6,
    height: 21.6,
    fill: "white",
    transform: "translate(19.7002 19.2031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.17c298190291fdddc48d321096ee856f.svg";
export { ForwardRef as ReactComponent };